import { httpRequest } from '@/clients/http'
import { local } from '@/db/repositories/local'
import * as customers from '@/db/repositories/customers'
import { configService } from '@/services/ConfigService'
import { Paginated, PosHttpParams, PosModel, PosSync } from '@/types'

// Customers outside this branch's pull: asked from the server by exact phone or card, then kept on the device.
const findOnline = async (search: string) => {
  if (!/^\+?\d{8,}$/.test(search) || !navigator.onLine) return false
  const res = await httpRequest<{ result: PosSync.LocalRow[] }>({ method: 'get', url: '/api/backoffice/pos-offline/customers', query: { search } })
  if (!res.success || !res.data?.result.length) return false
  await customers.saveFoundCustomers(res.data.result)
  return true
}

export const CustomerModel = {
  getList: async (query?: PosHttpParams.CustomerList) => {
    if (configService.isDemo()) return httpRequest<Paginated<PosModel.Customer>>({ method: 'get', url: '/pos/customers', query: { ...query } })
    const res = await local(customers.getCustomers(query))
    const search = query?.search?.trim() ?? ''
    if (res.success && res.data?.items.length === 0 && search && (await findOnline(search))) return local(customers.getCustomers(query))
    return res
  },

  create: (body: PosHttpParams.CreateCustomer) =>
    configService.isDemo()
      ? httpRequest<PosModel.Customer>({ method: 'post', url: '/pos/customers', body })
      : local(customers.createCustomer(body)),

  /** Device only: edited on the device and synced. */
  update: (id: string, body: PosHttpParams.CreateCustomer) => local(customers.updateCustomer(id, body)),

  /** Device only: the demo customers have no cards. */
  getByBarcode: async (code: string) => {
    const res = await local(customers.getCustomerByBarcode(code))
    if (res.success && !res.data && (await findOnline(code))) return local(customers.getCustomerByBarcode(code))
    return res
  },

  /** Device only: the demo API has no credit. */
  repayCredit: (customerId: string, amount: number, method: string, remark?: string) =>
    local(customers.recordRepayment(customerId, amount, method, remark)),
}
